import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AuthPage = lazy(() => import('../pages/auth/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const UserPage = lazy(() => import('../pages/user/page'));
const PostPage = lazy(() => import('../pages/post/page'));
const JobPage = lazy(() => import('../pages/job/page'));
const JobDetailPage = lazy(() => import('../pages/job-detail/page'));
const SearchPage = lazy(() => import('../pages/search/page'));
const NotificationsPage = lazy(() => import('../pages/notifications/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/auth',
    element: <AuthPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '/user/:userId',
    element: <UserPage />,
  },
  {
    path: '/post/:postId',
    element: <PostPage />,
  },
  {
    path: '/job',
    element: <JobPage />,
  },
  {
    path: '/job/:id',
    element: <JobDetailPage />,
  },
  {
    path: '/search',
    element: <SearchPage />,
  },
  {
    path: '/notifications',
    element: <NotificationsPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;